import React, { FC } from 'react';
import { withTranslation, WithTranslation } from '@wix/yoshi-flow-editor';

type Props = {
  name: string;
  dataHook: string;
  className?: string;
  role?: string;
} & WithTranslation;

const Genre: FC<Props> = ({ name, dataHook, t, className, role }) => {
  if (!name) {
    return null;
  }

  const translatedName = t(`shared.genres.${name.toLowerCase()}`);

  return (
    <span
      aria-label={t('widget.a11y.video.genre', {
        name: translatedName,
      })}
      data-hook={dataHook}
      className={className}
      role={role}
    >
      <span aria-hidden="true">{translatedName}</span>
    </span>
  );
};

export default withTranslation()(Genre);
